// extracted by mini-css-extract-plugin
export default {"jackpotMobileWidget":"JackpotMobileWidget_jackpotMobileWidget--VJC"};